module.exports = __webpack_public_path__ + "static/img/mini_progrom.1bcfc06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/official/mini_progrom.jpg
// module id = FuNL
// module chunks = 0